import React, { forwardRef, ImgHTMLAttributes } from 'react';

export const Image = forwardRef<HTMLImageElement, Props>(({
    alt = '',
    crossOrigin = 'anonymous',
    draggable = false,
    ...props
}, ref) => (
    <img
        draggable={draggable}
        crossOrigin={crossOrigin}
        loading='lazy'
        alt={alt}
        ref={ref} {...props} />
));

type Props = ImgHTMLAttributes<HTMLImageElement>;